/**
 * Authenticated fetch wrapper.
 * Attaches JWT Bearer token and handles 401 → redirect to login.
 */

import CONFIG from '../config';

function getAuthToken() {
  return localStorage.getItem('auth_token');
}

export async function authFetch(url, options = {}) {
  const token = getAuthToken();
  if (token) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  const response = await fetch(url, options);
  if (response.status === 401) {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    window.location.reload();
    throw new Error('Session expired');
  }
  return response;
}

/**
 * Build a stream URL carrying a short-lived SSE ticket instead of the session
 * token (EventSource cannot set headers; tickets keep the session JWT out of
 * URLs and access logs). The backend rejects any query-param token that is not
 * an sse ticket, so a non-ok ticket response throws: callers fall back to their
 * own reconnect/backoff path rather than building a URL that would 401.
 */
export async function getStreamUrl(url) {
  const res = await authFetch(`${CONFIG.apiUrl}/api/auth/sse-ticket`, { method: 'POST' });
  if (!res.ok) {
    throw new Error(`SSE ticket request failed: ${res.status}`);
  }
  const data = await res.json();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${encodeURIComponent(data.ticket)}`;
}
